var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/check-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/check-circle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4770563,1.95280662 C16.9815288,2.17758643 17.2082645,2.76876221 16.9834847,3.27323469 C16.7587049,3.77770717 16.1675291,4.00444289 15.6630566,3.77966309 C12.022298,2.15743584 7.74817307,3.12311787 5.1585034,6.15302801 C2.56883372,9.18293816 2.28052159,13.5553016 4.4499162,16.8990228 C6.61931082,20.242744 10.7296264,21.7612931 14.5518738,20.631174 C18.3741212,19.5010548 20.9977777,15.9914804 21.0000565,12.0062349 L21.0000565,11.0862349 C21.0000565,10.5339501 21.4477717,10.0862349 22.0000565,10.0862349 C22.5523412,10.0862349 23.0000565,10.5339501 23.0000565,11.0862349 L23.0000565,12.0068066 C22.9972709,16.8783611 19.7905797,21.1678409 15.118944,22.5490977 C10.4473082,23.9303545 5.4235892,22.07435 2.77210689,17.9875796 C0.120624583,13.9008092 0.473006087,8.5568095 3.63815791,4.85358598 C6.80330973,1.15036247 12.0272402,-0.029915564 16.4770563,1.95280662 Z M22.7068098,3.29877478 C23.0975292,3.68910386 23.0978456,4.32226876 22.7075165,4.71298817 L12.7075165,14.7229882 C12.3170495,15.1138457 11.683612,15.1140039 11.2929497,14.7233416 L8.29294968,11.7233416 C7.90242539,11.3328173 7.90242539,10.6996524 8.29294968,10.3091281 C8.68347397,9.91860378 9.31663895,9.91860378 9.70716324,10.3091281 L12.0000565,12.6012349 L21.2925964,3.29948154 C21.6829255,2.90876213 22.3160904,2.90844571 22.7068098,3.29877478 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.ae64aa1671115477014bec900c51350e.svg";
export { ForwardRef as ReactComponent };